import * as React from 'react'
import { cn } from '@/lib/utils'

type BadgeVariant =
  | 'default'
  | 'paid'
  | 'overdue'
  | 'pending'
  | 'draft'
  | 'credit'
  | 'invited'
  | 'committee'
  | 'estate_manager'
  | 'admin'
  | 'member'

const variantClasses: Record<BadgeVariant, string> = {
  default: 'bg-status-draft-bg text-status-draft-text',
  paid: 'bg-status-paid-bg text-status-paid-text',
  overdue: 'bg-status-overdue-bg text-status-overdue-text',
  pending: 'bg-status-pending-bg text-status-pending-text',
  draft: 'bg-status-draft-bg text-status-draft-text',
  credit: 'bg-status-credit-bg text-status-credit-text',
  invited: 'bg-status-invited-bg text-status-invited-text',
  committee: 'bg-navy text-cream',
  estate_manager: 'bg-green text-cream',
  admin: 'bg-ink text-cream',
  member: 'bg-status-draft-bg text-status-draft-text',
}

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant
}

function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 font-sans text-[11px] font-medium uppercase tracking-wide',
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  )
}

export { Badge }
